import script from "./MakeyMakeyBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./MakeyMakeyBadge.vue?vue&type=script&setup=true&lang=js"

import "./MakeyMakeyBadge.vue?vue&type=style&index=0&id=f1d33d6a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1d33d6a"]])

export default __exports__